import styled, { CSSObject } from 'styled-components';
import {
    colorPrimary,
    mediaMd,
    mediaSm,
    mediaXs,
} from 'theme/theme-helper-selectors';

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    margin: 0 0 40px 0;

    @media (${mediaMd}) {
        flex-direction: column;
        align-items: flex-start;

        button,
        a {
            margin: 20px 0 0 0;
        }
    }
`;

export const Left = styled.div`
    width: 50%;
    min-height: 85px;

    @media (${mediaSm}) {
        width: 100%;
        margin: 0 0 20px 0;
        min-height: 0px;
    }
`;

export const PriceDescription = styled.p<{ styles?: CSSObject }>`
    font-size: 24px;
    line-height: 28px;
    font-weight: 300;

    ul,
    ol {
        padding: 0;
        li {
            margin: 0 0 13px 0;
        }
    }

    ul {
        list-style: none;

        li {
            position: relative;
            padding: 0 0 0 10px;

            &:before {
                content: '';
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 0;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background: #23d1ae;
                flex-shrink: 0;
            }
        }
    }

    ${({ styles }) => ({ ...styles })};

    display: flex;
    flex-direction: row;
`;

export const Right = styled.div`
    width: 50%;

    @media (${mediaSm}) {
        width: 100%;
    }

    ${PriceDescription} {
        color: #2a3541b2;
    }
`;

export const Price = styled.div`
    &:not(&:last-child) {
        margin: 0 0 80px 0;
    }
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    z-index: 10;

    @media (${mediaMd}) {
        gap: 20px;
    }

    @media (${mediaSm}) {
        flex-direction: column;
        gap: 0px;
    }
`;

export const PriceTitle = styled.h3`
    color: ${colorPrimary};
    font-weight: 500;
    font-size: 64px;
    line-height: 52px;
    margin: 0 0 20px 0;
`;

export const ButtonCourses = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    height: 48px;
    z-index: 100;
    @media (${mediaMd}) {
        flex-direction: row;
        height: auto;
    }
    @media (${mediaXs}) {
        margin-top: 20px;
        flex-direction: column;
        width: 100%;
        a,
        button {
            margin-top: 0px;
        }
    }
`;

export const EmptyBlock = styled.div`
    min-width: 200px;
    @media (${mediaMd}) {
        min-width: 0px;
    }
`;
